import { Component } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {

  constructor(
  ) { }

  email: string = '';
  password: string = '';

  onKeyUpEmail(event: any) {
    this.email = event.target.value;
  }
  onKeyUpPassword(event: any) {
    this.password = event.target.value;
  }

  onLogin() {

  }

}
